jQuery(document).ready(($) => {
    
    $(".af-form-wrapper").on("submit", function(e){
        e.preventDefault();
        let listname = $("#newsletter-listname").val();
        let first_email = $(".newsletter__form__email")[0];
        let second_email = $(".newsletter__form__email")[1];
        let email = $(first_email).val() == "" ? $(second_email).val() : $(first_email).val();
        let name = email.split("@")[0];
        let subscriber_data = JSON.stringify({ 'listname' : listname, 'email' : email , 'name' : name, info_checkbox: 'Spielbankspezialist' });
        let home_url = window.location.origin;
        let loading = '<img src="'+home_url+'/wp-content/themes/spielbankspezialist.com-child/assets/images/newsletter/loading.gif" alt="Loading">';
        $('.newsletter__form__submit').html(loading);
        $.ajax({
            type: "POST",
            dataType: 'json',
            url: script_object.ajax_url,
            data: {
                action: 'aweber_subscribe',
                subscribe_data: subscriber_data
            },
            success: function(data) {
                $('.newsletter__form__submit').text('Abonnieren');
                if (data.fail) {
                    if(email == '') {
                        data.error = 'Fehlende Felder.';
                    } else if (data.error == 'email: Email address blocked. Please refer to https://help.aweber.com/hc/en-us/articles/204029356 .') {
                        data.error = 'Die E-Mail Adresse ist blockiert.';
                    } else if(data.error == 'email: Subscriber already subscribed.' || data.error == 'Subscriber already subscribed.') {
                        data.error = 'Der Benutzer ist bereits Abonnent.';
                    } else {
                        data.error = 'Ungültige E-Mail Adresse.';
                    }
                    
                    $(".newsletter__form__error").html(data.error).show();
                    setTimeout(function() { $(".newsletter__form__error").html(data.error).hide(); }, 5000);
                }
                if (data.success) {
                    $(".newsletter__form__error").hide();
                    $('.newsletter__form__submit').text('Abonnieren');
                    $(".newsletter__form__success").show();
                }
            },
            error: function (xhr, status, error) {
                //console.log(status);
            }
        });
    });
})